import StorageManager from '../StorageManager'
import { countryManager } from '../CountryManager'
import isNumber from 'lodash/isNumber'
import mapValues from 'lodash/mapValues'
import { TILE_SIZES, getSizesData } from '@mixtiles/web-backend-shared'
import { MIXED_SIZES } from '../../pages/PhotoStyler/TileDesignerConsts'
import { translateManager, translateManager as t } from '../TranslateManager'
import { SELECTED_SIZE_KEY } from '../../hooks/tileStyling/utils'

export const SIZES_SHORT_NAMES = mapValues(TILE_SIZES, getShortSizeName)

export function isSizesInInches(country) {
  return ['us', 'ca'].includes(country.toLowerCase())
}

export function getSizeName(
  size,
  {
    country = countryManager.getPricingCountry(),
    t = translateManager.get,
  } = {}
) {
  if (size === MIXED_SIZES) {
    return t('order.styles.mixed_styles')
  } else {
    if (isSizesInInches(country)) {
      return getSizesData()[size]?.longDisplayName
    }
    return getSizesData()[size]?.longDisplayNameCms
  }
}

export function getSelectedSize() {
  return StorageManager.get(SELECTED_SIZE_KEY) || TILE_SIZES.SQUARE_8X8
}

export function getOrderSummarySizeText(tileSize, hideComma = false) {
  if (Array.isArray(tileSize)) {
    return tileSize.map((size) => getSizeName(size)).join(' / ')
  }
  let sizeText =
    tileSize === MIXED_SIZES
      ? t.get('designer.mixed_sizes').toLowerCase()
      : getSizeName(tileSize)
  if (!hideComma) {
    sizeText = `, ${sizeText}`
  } else {
    sizeText = ` ${sizeText}`
  }
  return sizeText
}

export function getShortSizeName(name) {
  const shouldKeepPrefix = name === MIXED_SIZES
  if (shouldKeepPrefix) {
    return name.toLowerCase()
  }
  if (name) {
    const nameParts = name.split('_')
    const shortName = nameParts[nameParts.length - 1]
    return isNumber(shortName) ? name : shortName
  }
  return 'none'
}

export const DEFAULT_DELIVERY_TIME = 10

export function getDeliveryTimeByCountry(ipCountry) {
  return ipCountry?.toLowerCase() === 'gb' ? 6 : DEFAULT_DELIVERY_TIME
}
